import { partner } from "../../js/path";

export default {
  data() {
    return {
      pageNo: null,
      partner_id: null,
      forum_tabs: {
        overview: {
          index: 1,
          label: "Overview",
          active: false,
        },
        videos: {
          index: 2,
          label: "Videos",
          active: false,
        },
        reading_material: {
          index: 3,
          label: "Reading Material",
          active: false,
        },
        cases: {
          index: 4,
          label: "Cases",
          active: false,
        },
        live_events: {
          index: 5,
          label: "Live Events",
          active: false,
        },
        podcasts: {
          index: 6,
          label: "Podcast",
          active: false,
        },
      },
      table_header: [],
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: 'website_banner_image',
          label: 'Banner'
        },
        {
          key: "title",
          label: 'Partner Name'
        },
        {
          key: 'link_name',
          label: 'Link Name'
        },
        {
          key: "is_active",
          label: "Status",
        },
        {
          key: 'is_visible_in_home',
          label: 'Visibility'
        },
        {
          key: "edit",
        },
        {
          key: "delete",
        },
      ],
      params: "",
      activeTab: "all",
      key: 0,
      sortBy: "id",
      sortDesc: true,
      tableData: [],
      filter: null,
      filterOn: [],
      currentPage: 1,
      form: {
        title: "",
        link_name: "",
        description: "",
        meta_title: "",
        meta_description: "",
        meta_keywords: "",
        is_visible_in_home: 0,
      },
      app_banner_image: "",
      open_page_register_image: "",
      app_logo_image: "",
      website_banner_image: "",
      open_page_banner_img: "",
      app_banner_image_url : "",
      open_page_register_image_url: "",
      app_logo_image_url: "",
      website_banner_image_url: "",
      open_page_banner_img_url: "",
      edit: {
        app_banner_image_url: null,
        open_page_register_image_url: null,
        app_logo_image_url: null,
        website_banner_image_url: null,
        open_page_banner_img_url: null,
      },
    };
  },
  methods: {
    getLink(linkName) {
      window.open(this.$hostLink + '/partner-details/' + linkName);
    },
    slugify() {
      this.partner_title = this.form.title;
      if (this.partner_title) {
        const slug_generate = this.partner_title
          .toString()
          .trim()
          .toLowerCase()
          .replace(/\s+/g, "-")
          .replace(/[^\w-]+/g, "")
          .replace(/--+/g, "-")
          .replace(/^-+/, "");
        this.form.link_name = slug_generate;
      } else {
        this.form.link_name = null;
      }
    },
    search(event) {
      if (this.filter.length > 1) {
        if (event.keyCode == 13) {
          this.currentPage = 1;
          this.fetchData(this.activeTab);
        }
      }
      else if (this.filter.length == 0) {
        this.currentPage = 1;
        this.fetchData(this.activeTab);
      } 
    },
    searchFor(){
      if (this.filter.length > 0) {
        this.currentPage = 1;
        this.fetchData(this.activeTab);
      } else {
        this.currentPage = 1;
        this.fetchData(this.activeTab);
      }
    },
    filterPage() {
      if (this.pageNo.length > 0) {
         this.params = `&page=${this.pageNo}`;
         this.fetchData(this.activeTab);
         this.currentPage = this.pageNo;
      }
   },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async fetchData(txt) {
      let url = null;
      if (txt == "active") {
        this.activeTab = txt;
        if (this.filter != null && this.filter != "") {
          url =
            partner.partnerUrl + "?filter=" + txt + "&search=" + this.filter;
        } else {
          url = partner.partnerUrl + "?filter=" + txt;
        }
      } else if (txt == "trash") {
        this.activeTab = txt;
        if (this.filter != null && this.filter != "") {
          url =
            partner.partnerUrl + "?filter=" + txt + "&search=" + this.filter;
        } else {
          url = partner.partnerUrl + "?filter=" + txt;
        }
      } else if (txt == "all") {
        this.activeTab = txt;
        if (this.filter != null && this.filter != "") {
          url =
            partner.partnerUrl + "?filter=" + txt + "&search=" + this.filter;
        } else {
          url = partner.partnerUrl + "?filter=" + txt;
        }
      }
      url += this.params;
      this.getUrl();
      this.$store.commit("loader/updateStatus", true);
      try {
        const data = await this.getRequest(url);
        if (data.status) {
          const responseData = data.response;
          this.tableData = responseData;
        }
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: "Fetching error!",
        });
      }
      this.$store.commit("loader/updateStatus", false);
      this.key += 1;
    },
    async fetchPartner(id) {
      this.$store.commit("loader/updateStatus", true);
      try {
        let url = partner.partnerUrl + "/" + id;
        const data = await this.getRequest(url);
        if (data.status) {
          const responseData = data.response;

          if(responseData.title != "" && responseData.title != null){
            this.form.title = responseData.title;
          }

          if(responseData.link_name != "" && responseData.link_name != null){
            this.form.link_name = responseData.link_name;
          }

          if(responseData.description != "" && responseData.description != null){
            this.form.description = responseData.description;
          }

          if(responseData.meta_title != "" && responseData.meta_title != null){
            this.form.meta_title = responseData.meta_title;
          }

          if(responseData.meta_description != "" && responseData.meta_description != null){
            this.form.meta_description = responseData.meta_description;
          }

          if(responseData.meta_keywords != "" && responseData.meta_keywords != null){
            this.form.meta_keywords = responseData.meta_keywords;
          }

          if (responseData.is_visible_in_home) {
            this.form.is_visible_in_home = true;
          }

          var forum_tabs = {};
          if (responseData.forum_tabs) {
            if(typeof responseData.forum_tabs == 'string'){
              forum_tabs = JSON.parse(responseData.forum_tabs);
            }else{
              forum_tabs = responseData.forum_tabs;
            }
          }
          if (responseData.forum_tabs){
            Object.entries(forum_tabs).forEach((d) => {
              forum_tabs[d[0]].active = (d[1].active == "on" || d[1].active == true) ? true : false;
            });
            this.forum_tabs = forum_tabs;
          }

          this.edit.app_banner_image_url = responseData.app_banner_image;
          this.app_banner_image = responseData.app_banner_image;

          this.edit.app_logo_image_url = responseData.app_logo_image;
          this.app_logo_image = responseData.app_logo_image;

          this.edit.open_page_banner_img_url =
            responseData.open_page_banner_img;
          this.open_page_banner_img = responseData.open_page_banner_img;

          this.edit.open_page_register_image_url =
            responseData.open_page_register_image;
          this.open_page_register_image = responseData.open_page_register_image;

          this.edit.website_banner_image_url =
            responseData.website_banner_image;
          this.website_banner_image = responseData.website_banner_image;

          this.partner_id = responseData.id;
        }
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      }
      this.$store.commit("loader/updateStatus", false);
    },
    getUrl() {
      var url = new URL(window.location);
      if (this.activeTab == null || this.activeTab == "") {
        this.activeTab = "all";
      }
      (url.searchParams.has('filter') ? url.searchParams.set('filter', this.activeTab) : url.searchParams.append('filter', this.activeTab));
      if (this.filter != null && this.filter != "") {
        (url.searchParams.has('search') ? url.searchParams.set('search', this.filter) : url.searchParams.append('search', this.filter));
      }
      else {
        url.searchParams.delete('search');
      }
      if (this.currentPage != null && this.currentPage != "") {
        (url.searchParams.has('page') ? url.searchParams.set('page', this.currentPage) : url.searchParams.append('page', this.currentPage));
      }
      else {
        url.searchParams.set('page', 1);
      }
      url.search = url.searchParams;
      url = url.toString();
      history.pushState({}, null, url);
    },
    async updateStatus(id) {
      try {
        let index = this.tableData.data.findIndex((e) => e.id === id);
        const url = partner.statusUpdate + "/" + id;
        const data = await this.postRequest(url, {
          is_active: !this.tableData.data[index].is_active,
        });
        if (data.status) {
          const responseData = data.response;
          this.tableData.data[index] = responseData;
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: data.message,
          });
        }
        this.key += 1;
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      }
    },
    async deletePartner(id) {
      let index = this.tableData.data.findIndex((e) => e.id === id);
      const url = partner.partnerUrl + "/" + id;
      const data = await this.postRequest(url, {
        _method: "DELETE",
      });
      if (data.status) {
        this.tableData.data.splice(index, 1);
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "success",
          title: data.message,
        });
      }
    },
    async restorePartner(id) {
      let index = this.tableData.data.findIndex((e) => e.id === id);
      const url = partner.restorePartner + "/" + id;
      const data = await this.postRequest(url, {});
      if (data.status) {
        this.tableData.data.splice(index, 1);
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "success",
          title: data.message,
        });
      } else {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: "Please try again!",
        });
      }
    },
    readFile(e, txt) {
      if (txt == "app_banner_image") {
        this.app_banner_image = e.target.files[0];
        if (this.app_banner_image.size > 2 * 1000 * 1000) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: "Uploaded File is More than 2MB"
          });
          this.$refs.app_banner_image.reset();
          this.app_banner_image_url = '';
          this.edit.app_banner_image_url = '';
          this.app_banner_image = '';
          return false;
        } else {
          this.app_banner_image_url = URL.createObjectURL(this.app_banner_image);
          this.edit.app_banner_image_url = '';
        }
        return true;
      } else if (txt == "open_page_register_image") {
        this.open_page_register_image = e.target.files[0];
        if (this.open_page_register_image.size > 2 * 1000 * 1000) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: "Uploaded File is More than 2MB"
          });
          this.$refs.open_page_register_image.reset();
          this.open_page_register_image_url = '';
          this.edit.open_page_register_image_url = '';
          this.open_page_register_image = '';
          return false;
        } else {
          this.open_page_register_image_url = URL.createObjectURL(this.open_page_register_image);
          this.edit.open_page_register_image_url = '';
        }
        return true;
      } else if (txt == "app_logo_image") {
        this.app_logo_image = e.target.files[0];
        if (this.app_logo_image.size > 2 * 1000 * 1000) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: "Uploaded File is More than 2MB"
          });
          this.$refs.app_logo_image.reset();
          this.app_logo_image_url = '';
          this.edit.app_logo_image_url = '';
          this.app_logo_image = '';
          return false;
        } else {
          this.app_logo_image_url = URL.createObjectURL(this.app_logo_image);
          this.edit.app_logo_image_url = '';
        }
        return true;
      } else if (txt == "website_banner_image") {
        this.website_banner_image = e.target.files[0];
        if (this.website_banner_image.size > 2 * 1000 * 1000) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: "Uploaded File is More than 2MB"
          });
          this.$refs.website_banner_image.reset();
          this.website_banner_image_url = '';
          this.edit.website_banner_image_url = '';
          this.website_banner_image = '';
          return false;
        } else {
          this.website_banner_image_url = URL.createObjectURL(this.website_banner_image);
          this.edit.website_banner_image_url = '';
        }
        return true;
      } else if (txt == "open_page_banner_img") {
        this.open_page_banner_img = e.target.files[0];
        if (this.open_page_banner_img.size > 2 * 1000 * 1000) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: "Uploaded File is More than 2MB"
          });
          this.$refs.open_page_banner_img.reset();
          this.open_page_banner_img_url = '';
          this.edit.open_page_banner_img_url = '';
          this.open_page_banner_img = '';
          return false;
        } else {
          this.open_page_banner_img_url = URL.createObjectURL(this.open_page_banner_img);
          this.edit.open_page_banner_img_url = '';
        }
        return true;
      }
    },
    async submitData() {
      this.$store.commit("loader/updateStatus", true);
      try{
        let url = partner.partnerUrl;
        if(this.$route.name == 'edit-partner'){
          url = partner.partnerUrl + '/' + this.partner_id;
        }
        let dataAppend = new FormData();

        if (typeof this.app_banner_image === 'string') {
          if (this.app_banner_image.includes("https://")) {
            this.app_banner_image = "";
          }
        }

        if(this.app_banner_image){
          dataAppend.append("app_banner_image", this.app_banner_image);
        }

        if (typeof this.open_page_register_image === 'string') {
          if (this.open_page_register_image.includes("https://")) {
            this.open_page_register_image = "";
          }
        }

        if(this.open_page_register_image){
          dataAppend.append(
            "open_page_register_image",
            this.open_page_register_image
          );
        }
        
        if (typeof this.app_logo_image === 'string') {
          if (this.app_logo_image.includes("https://")) {
            this.app_logo_image = "";
          }
        }

        if(this.app_logo_image){
          dataAppend.append("app_logo_image", this.app_logo_image);
        }

        if (typeof this.website_banner_image === 'string') {
          if (this.website_banner_image.includes("https://")) {
            this.website_banner_image = "";
          }
        }        

        if(this.website_banner_image){
          dataAppend.append("website_banner_image", this.website_banner_image);
        }

        if (typeof this.open_page_banner_img === 'string') {
          if (this.open_page_banner_img.includes("https://")) {
            this.open_page_banner_img = "";
          }
        }  

        if(this.open_page_banner_img){
          dataAppend.append("open_page_banner_img", this.open_page_banner_img);
        }

        for (var key in this.form) {
          dataAppend.append(key, this.form[key]);
        }
        if (this.form.is_visible_in_home) {
          dataAppend.append("is_visible_in_home", 1);
        } else {
          dataAppend.append("is_visible_in_home", 0);
        }
        dataAppend.append("forum_tabs", JSON.stringify(this.forum_tabs));

        if (this.$route.name == "edit-partner") {
          dataAppend.append("_method", "put");
        }

        const data = await this.postRequest(url, dataAppend);
        if (data.status) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: data.message,
          });
          this.$router.push("/partner");
        }
      }
      catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      }
      this.$store.commit("loader/updateStatus", true);
    },
    tabActive() {
      if (this.activeTab == "trash") {
        if (this.table_header.includes("delete")) {
          let index = this.fields.findIndex((item) => item.key == "delete");
          this.fields[index] = {
            key: "restore",
          };
          let table_index = this.table_header.findIndex((item) => item == "delete");
          this.table_header[table_index] = "restore";

        } else {
          this.table_header.push("restore");
          this.fields.push({
            key: "restore",
          });
        }

        if (!this.can("restore-partner")) {
          let index = this.fields.findIndex((item) => item.key == "restore");
          if (index !== -1) {
            this.fields.splice(index, 1);
            let table_index = this.table_header.findIndex(
              (item) => item == "restore"
            );
            this.table_header.splice(table_index, 1);
          }
        }

        let index = this.fields.findIndex((item) => item.key == "edit");
        if (index !== -1) {
          this.fields.splice(index, 1);
          let table_index = this.table_header.findIndex(
            (item) => item == "edit"
          );
          this.table_header.splice(table_index, 1);
        }
      } else {
        if (this.table_header.includes("restore")) {
           if (!this.can("edit-partner")) {
             this.fields[5] = {
               key: "delete",
             };
           } else {
             this.fields[6] = {
               key: "delete",
             };
           }
 
           let table_index = this.table_header.findIndex((item) => item == "restore");
           this.table_header[table_index] = "delete";
        }

        if (!this.can("edit-partner")) {
          let index = this.fields.findIndex((item) => item.key == "edit");
          if (index !== -1) {
            this.fields.splice(index, 1);
            let table_index = this.table_header.findIndex(
              (item) => item == "edit"
            );
            this.table_header.splice(table_index, 1);
          }
        } else {
          if (!this.table_header.includes("edit")) {
            this.table_header.push("edit");
            this.fields[5] = {
              key: "edit",
            };
          }
        }

        if (!this.can("delete-partner")) {
          let index = this.fields.findIndex((item) => item.key == "delete");
          if (index !== -1) {
            this.fields.splice(index, 1);
            let table_index = this.table_header.findIndex(
              (item) => item == "delete"
            );
            this.table_header.splice(table_index, 1);
          }
        } else {
          if (!this.table_header.includes("delete")) {
            this.table_header.push("delete");
            this.fields[6] = {
              key: "delete",
            };
          }
        }
      }
    },
  },
  watch: {
    currentPage: {
      handler: function (value) {
        this.params = `&page=${value}`;
        this.fetchData(this.activeTab);
        this.pageNo = this.currentPage;
      },
    },
    "form.is_visible_in_home"(v) {
      if (v == 1) {
        this.form.is_visible_in_home = true;
      } else {
        this.form.is_visible_in_home = false;
      }
    },
    activeTab(v) {
      if (v) this.tabActive();
    },
  },
  mounted() {
    if (
      this.$route.name == "add-partner" ||
      this.$route.name == "edit-partner"
    ) {
      if (this.$route.name == "edit-partner") {
        this.fetchPartner(this.$route.params.id);
      }
    } else {
      this.activeTab = "all";
      if (this.$route.query.filter) {
        this.activeTab = this.$route.query.filter;
      }
      if (this.$route.query.search) {
        this.filter = this.$route.query.search;
      }
      if (this.$route.query.page && this.$route.query.page != 1) {
        this.currentPage = parseInt(this.$route.query.page);
      } else {
        this.fetchData(this.activeTab);
      }
    }
    this.fields.map((item) => {
      this.table_header.push(item.key);
    });
    this.tabActive();
  },
};
